export default "__VITE_ASSET__CeZdN2wG__"